const BASE_URL =
  process.env.NODE_ENV === "production"
    ? "https://mtg-app-backend-7c170e7e1298.herokuapp.com/api"
    : "http://localhost:5000/api";

    export const fetchCards = async (query) => {
      try {
        const encodedQuery = encodeURIComponent(query); 
        const res = await fetch(`${BASE_URL}/cards?q=${encodedQuery}`);
        if (!res.ok) throw new Error("Failed to fetch cards");
        
        const data = await res.json();
        return Array.isArray(data) ? data : []; // always return array to avoid map error
      } catch (err) {
        console.error('Error fetching cards:', err.message);
        return []; // fallback empty array
      }
    };
    
